__turbopack_context__.v({
  "fade-in": "Description-module-scss-module__rlmota__fade-in",
  "inner": "Description-module-scss-module__rlmota__inner",
  "root": "Description-module-scss-module__rlmota__root",
});
